export default "__VITE_ASSET__deAnHxR8__"